import { render, staticRenderFns } from "./linkButton.vue?vue&type=template&id=a89bc624&scoped=true"
import script from "./linkButton.vue?vue&type=script&lang=js"
export * from "./linkButton.vue?vue&type=script&lang=js"
import style0 from "./linkButton.vue?vue&type=style&index=0&id=a89bc624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89bc624",
  null
  
)

export default component.exports